import { UserContext } from "context";
import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import {
  deleteKeyRequest,
  deleteUserData,
  getAllEvent,
  getKeyRequest,
  handleKeyDown,
  updateKeyRequest,
} from "_services";
import {
  ButtonHeading,
  CommonInput,
  CommonModal,
  CommonPagination,
  CustomPagination,
} from "components";
import BootstrapTable from "components/BootstrapTable";
import { deleteGuest, getGuest } from "_services/guestServices";
import { AddGuestModal } from "modals";
import MastersFilterModal from "modals/MastersFilterModal";
import { errorSchema, utils } from "helper";

const KeyRequest = () => {
  const userTypeList = [
    { label: "ADMIN", value: 1 },
    { label: "GUEST", value: 2 },
    { label: "STAFF", value: 3 },
  ];

  const genderList = [
    { label: "MALE", value: 1 },
    { label: "FEMALE", value: 2 },
  ];

  const { masterData,userType } = useContext(UserContext);
  const navigate = useNavigate();
  const loadingBarRef = useRef(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [allKeyList, setAllKeyList] = useState([]);
  const [addressId, setAddressId] = useState("");
  const [eventView, setEventView] = useState(false);
  const [allEventList, setAllEventList] = useState([]);
  const [keyId, setKeyId] = useState("");
  const [OTP, setOTP] = useState("");
  const [formError, setFormError] = useState("");

  const [filter, setFilter] = useState({
    limit: 15,
    event_id: "",
    reason: "",
  });
  const remarkRef = useRef();
  const itemsPerPage = 15;
  const [totalItems, setTotalItems] = useState(0);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [prevPageUrl, setPrevPageUrl] = useState(null);
  const [form, setForm] = useState({
    verify_otp: "",
  });

  const reasonList = {
    1: "KEY LOST",
    2: "LOCKER UNLOCK REQUEST",
    3: "MASTER KEY ACCESS",
  };

  const reasonLists = [
    { label: "KEY LOST", value: 1 },
    { label: "LOCKER UNLOCK REQUEST", value: 2 },
    { label: "MASTER KEY ACCESS", value: 3 },
  ];

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Event ", accessor: "event_name" },
    { header: "Room ", accessor: "room_number" },
    { header: "Reason", accessor: "reasonText" },
    { header: "Date", accessor: "keyDate" },
    // { header: "Verify Code", accessor: "verification_code" },
    { header: "Status", accessor: "is_verified" },
    { header: "", accessor: "action" },
  ];

  useEffect(() => {
    getKeyRequestList();
  }, [filter]);

  useEffect(() => {
    getEventList();
  }, []);

const getEventList = async () => {
  try {
    const res = await getAllEvent({ limit: "all" });

    if (res?.status === 200) {
      const filterEvent = res.results?.map((i) => ({
        ...i,
        label: i?.event_name,
        value: i?.id,
      }));

      console.log(filterEvent);

      const activeEvent = filterEvent?.find((e) => e.is_active === true);

      setFilter((prev) => ({
        ...prev,
        event_id: activeEvent?.id || null,
      }));

      setAllEventList(filterEvent);
    } else {
      toast.error(res.error || "Failed to fetch events.");
    }
  } catch (error) {
    toast.error(error?.message || "Something went wrong.");
  }
};

  // const getKeyRequestList = async (url = null) => {
  //   try {
  //     if (loadingBarRef.current) {
  //       loadingBarRef.current.continuousStart();
  //     }
  //     const filterParams = new URLSearchParams();

  //     Object.keys(filter).forEach((key) => {
  //       if (filter[key]) {
  //         filterParams.append(key, filter[key]);
  //       }
  //     });

  //     const urlmodify = `${url}?${filterParams.toString()}`;

  //     const res = await getKeyRequest(url, filterParams.toString());

  //     if (res?.status === 200) {
  //       setAllKeyList(res?.results);
  //       setNextPageUrl(res?.next);
  //       setPrevPageUrl(res?.previous);
  //       setTotalItems(res?.count);
  //     } else {
  //       toast.error(res.error);
  //     }
  //   } catch (error) {
  //     toast.error(error);
  //   } finally {
  //     if (loadingBarRef.current) {
  //       loadingBarRef.current.complete();
  //     }
  //   }
  // };

  const getKeyRequestList = async (url = null) => {
    try {
      // Start loading bar if available
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart();
      }
  
      // Prepare filter query parameters
      const filterParams = new URLSearchParams();

      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          filterParams.set(key, value); // use set instead of append to avoid duplicates
        }
      });
  
      // Use base URL or fallback to default API URL
      const requestUrl = url || null
  
      // Fetch key request list
      const res = await getKeyRequest(requestUrl, filterParams.toString());
  
      // Handle response
      if (res?.status === 200) {
        setAllKeyList(res?.results || []);
        setNextPageUrl(res?.next || null);
        setPrevPageUrl(res?.previous || null);
        setTotalItems(res?.count || 0);
      } else {
        toast.error(res?.error || "Failed to fetch key requests.");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong.");
    } finally {
      // Stop loading bar if available
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
    }
  };
  

  const deleteHandler = (item) => {
    setIsDelete(item);
  };

  const statusChangeHnadle = async (data, index) => {};

  const handleStatusEvent = async (data, index) => {
    statusChangeHnadle(data, index);
    const list = [...allKeyList];
    list[index].active = data?.active === 1 ? 0 : 1;
    setAllKeyList(list);
  };

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serial: (
        <React.Fragment>
          <div className="signDropdown">
            <button className="dropbtn11">
              <BsThreeDotsVertical />
            </button>
            <div className="dropdownContent">
              <Link
                onClick={() => {
                  setEventView(item?.id);
                  setAddressId(item?.id);
                  setShowOffcanvas(true);
                }}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>
              <Link
                onClick={() => {
                  setAddressId(item?.id);
                  setShowOffcanvas(true);
                }}
                className="_avPointer"
                style={{ textDecoration: "none" }}
              >
                <span className="_samAnchor">
                  <span className="viewIcon_avt">
                    <FiEdit />
                  </span>
                  &nbsp; Edit
                </span>
              </Link>
              {/* <div
                    
                    className='_avPointer'
                  >
                    <span className='_samAnchor'>
                      <span className='editIcon_avt'>
                        <FiEdit />
                      </span>
                      Edit
                    </span>
                  </div> */}

              <div onClick={(e) => deleteHandler(item)} className="_avPointer">
                <span className="_samAnchor">
                  <span className="deleteIcon_avt">
                    <FaRegTrashCan color="red" />
                  </span>
                  Delete
                </span>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),

      is_verified: (
        <>
          {item?.is_verified ? (
            <div
              className="_anvSwitcherNew form-check form-switch"
              style={{ width: "125px" }}
            >
              {/* <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item.is_verified}`}
            autoComplete="off"
            checked={item?.is_verified}
            // onChange={() => handleStatusEvent(item, i)}
          /> */}
              <span
                className={
                  item?.is_verified
                    ? "active_label_masters_status"
                    : "disabled_label_masters_status"
                }
              >
                {item?.is_verified ? "Verifed" : "Not Verify"}
              </span>
            </div>
          ) : (
            <React.Fragment>
              <div
                className="_anvSwitcherNew form-check form-switch"
                style={{ width: "150px" }}
              >
                {!item?.check_out && (
                  <div className="_listbtn">
                    <button
                      className="_addComm_btn _builtyPrintBtn"
                      onClick={() => setKeyId(item)}
                    >
                      Verify OTP
                    </button>
                  </div>
                )}
              </div>
            </React.Fragment>
          )}
        </>
      ),
      supplier_name: (
        <Link style={{ textDecoration: "none" }}>
          {item?.company_user_name ? item?.company_user_name : "-"}
        </Link>
      ),
      contact_number: (
        <React.Fragment>
          {item?.user_id?.mobile_no ? item?.user_id?.mobile_no : "-"}
        </React.Fragment>
      ),

      category: (
        <React.Fragment>
          {userTypeList.find((fx) => fx?.value == item?.user_type)?.label}
        </React.Fragment>
      ),
      genderValue: (
        <React.Fragment>
          {genderList.find((fx) => fx?.value == item?.gender)?.label}
        </React.Fragment>
      ),
      party_group: (
        <React.Fragment>
          {item?.consignor_group_id?.name
            ? item?.consignor_group_id?.name
            : "-"}
        </React.Fragment>
      ),
      // city: (
      //   <React.Fragment>
      //     {item?.city?.label ? item?.city?.label : "-"}
      //   </React.Fragment>
      // ),
      reasonText: <>{reasonList[item?.reason]}</>,
      keyDate: (
              <>
                {` ${utils.formatDateMonth(item?.created)} | ${utils.formatTime(
                  item?.created
                )}`}
              </>
            ),
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          <span
            className="viewIcon_avt"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate(`/keyrequest/view/${item?.id}/${true}`);
            }}
          >
            <AiOutlineEye color="green" />
          </span>
          
          {userType !=3 &&<span
            className="deleteIcon_avt"
            style={{ cursor: "pointer" }}
            onClick={(e) => deleteHandler(item)}
          >
            <FaRegTrashCan color="red" />
          </span>}
        </div>
      ),
      status: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "125px" }}
        >
          <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={item?.active}
            onChange={() => handleStatusEvent(item, i)}
          />
          <span
            className={
              item?.active
                ? "active_label_masters_status"
                : "disabled_label_masters_status"
            }
          >
            {item?.active ? "Active" : "Disabled"}
          </span>
        </div>
      ),

      balance: item?.balance ? (
        <Link
          to={`/account/supplier/details/${item?._id}?tab=4`}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              color:
                item.balance < 0
                  ? "#dc3545"
                  : item.balance > 0
                  ? "#28a745"
                  : "#1450ec",
            }}
          >
            <span></span>
            <span>{item.balance}</span>
          </div>
        </Link>
      ) : (
        <Link
          to={`/account/supplier/details/${item?._id}?tab=4`}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              color: "#1450ec",
            }}
          >
            <span></span>
            <span>0</span>
          </div>
        </Link>
      ),
    }));
  };

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.verifySchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const updateVerification = async (idVerify) => {
    const validationResult = await utils.checkFormError(
      {
        ...form,
      },
      errorSchema.verifySchema
    );
    const payload = {
      verification_code: form?.verify_otp,
    };

    try {
      if (validationResult === true) {
        setLoading(true);
        const res = await updateKeyRequest({
          payload,
          id: keyId?.id,
        });

        if (res.status === 200) {
          setLoading(false);
          getKeyRequestList();
          setKeyId(false);
          setOTP("");
          toast.success(res.message);
        } else {
          setLoading(false);
          setKeyId(false);
          setOTP("");
          getKeyRequestList();
          toast.error(res.error);
        }
      } else {
        setLoading(false);
        setFormError(validationResult);
      }
    } catch (error) {
      setFormError(validationResult);
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };

  const submitDeleteSupplier = async () => {
    setLoading(true);
    try {
      loadingBarRef.current?.continuousStart();
      let object = {
        id: isDelete?.id,
      };

      const res = await deleteKeyRequest(object);
      if (res?.status == 200) {
        toast.success(`${res?.message}`);
        getKeyRequestList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.error(res?.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const callBack = () => {
    getKeyRequestList();
    setAddressId("");
    setEventView(false);
  };

  const handleNextPage = () => {
    if (nextPageUrl) {
      getKeyRequestList(nextPageUrl);
    }
  };

  const handlePrevPage = () => {
    if (prevPageUrl) {
      getKeyRequestList(prevPageUrl);
    }
  };

  const callBackNext = () => {
    handleNextPage();
  };

  const callBackPre = () => {
    handlePrevPage();
  };

  const handleKey = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef && nextInputRef.current) {
        nextInputRef.current.focus();
      } else {
        // handleSubmit(e);
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteSupplier,
    isLoadding: loading,
  };

  let eventProps = {
    isOpen: showOffcanvas,
    closeModal: (e) => {
      setAddressId("");
      setShowOffcanvas(false);
      setEventView(false);
    },

    modalMainClass: "_dashCommon_Modal _smModal",
    loading: loading,
    modalTitle: addressId
      ? eventView
        ? "View Customer"
        : "Update Customer"
      : "Add Customer",
    submitTitle: addressId
      ? eventView
        ? "Customer"
        : "Update Customer"
      : "Add Customer",
    callBack: callBack,
    addressId: addressId,
    eventView: eventView,
  };

  let checkoutProps = {
    isOpen: keyId,
    closeModal: () => {
      setFormError("");
      setKeyId(false);
      setOTP("");
    },
    modalTitle: "OTP",
    submitTitle: "Verify",
    cancleTitle: "Close",
    onSubmit: updateVerification,
    isLoadding: loading,
  };
  return (
    <div>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      <ButtonHeading
        title={"Key Request"}
        onClick={() => navigate("/keyRequest/create")}
        buttonTitle={"Add Key Request"}
        showSearchFilter={{
          search: false,
          event_id: true,
          reason: true,
          filterOption: false,
          filterCount: true,
        }}
        list={{
          allEventList,
          reasonLists,
        }}
        onClickFilterModal={(e) => setShowFilterModal(true)}
        filter={filter}
        setFilter={setFilter}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(allKeyList?.length ? allKeyList : [])}
          isLoading={loading}
        />

        {allKeyList?.length > 0 && (
          <div className="paginationFt_avt ">
            {" "}
            <CommonPagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              handleNextPage={callBackNext}
              handlePrevPage={callBackPre}
            />
          </div>
        )}
      </div>

      {/* <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showOffcanvas ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
      ></div>

      <div className={showOffcanvas ? "offBack_drop" : ""}></div> */}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
            isShow={{
              mobile_number: true,
              gender: true,
              state: true,
              city: true,
            }}
            name="guest"
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {showOffcanvas && <AddGuestModal {...eventProps} />}

      {isDelete?.id && (
        <CommonModal {...propsObject}>
          <p className="p-3"> Do you really want to delete {isDelete?.name} </p>
        </CommonModal>
      )}

      {keyId?.id && (
        <CommonModal {...checkoutProps}>
          <div className="_plcMod_body" style={{ padding: "20px" }}>
            <div className="flxInr">
              <div className="singleDiv">
                <CommonInput
                  type="text"
                  label="OTP"
                  placeholder="Enter OTP"
                  name="verify_otp"
                  value={form?.verify_otp}
                  onChange={({ target: { name, value } }) => {
                    handleOnChange(name, value);
                  }}
                  onKeyPress={handleKeyDown}
                  maxLength={6}
                  focus={!!formError?.verify_otp}
                  error={formError.verify_otp}
                  ref={remarkRef}
                  onKeyDown={(e) => handleKey(e, null)}
                />
              </div>
              <div className="singleDiv"></div>
            </div>
          </div>
        </CommonModal>
      )}
    </div>
  );
};

export default KeyRequest;
